module.exports = __webpack_public_path__ + "img/9.bc0f0f3f.jpg";